export type Bonus = {
  number: string
  title: string
  subtitle: string
  body: string
  tags: string
  accent: string
  border: string
}

export const BONUSES: Bonus[] = [
  {
    number: '01',
    title: 'LEARNING PRACTICE LAB™',
    subtitle: 'The Complete Practice & Reinforcement Activity System',
    body: 'Turn understanding into practice with ready-to-use activities designed to reinforce essential learning concepts.',
    tags: 'Practice · Reinforcement · Application · Review',
    accent: 'bg-green',
    border: 'border-l-green',
  },
  {
    number: '02',
    title: 'GAMES & LEARNING CHALLENGES™',
    subtitle: 'Low-Prep Educational Games for Everyday Learning',
    body: 'Make learning more engaging with simple educational games and challenges that require minimal preparation.',
    tags: 'Games · Challenges · Memory · Learning',
    accent: 'bg-orange',
    border: 'border-l-orange',
  },
  {
    number: '03',
    title: 'REAL-LIFE LEARNING MISSIONS™',
    subtitle: 'Turn Everyday Moments Into Learning Opportunities',
    body: 'Help children connect what they learn with real situations and the world around them.',
    tags: 'Explore · Observe · Connect · Apply',
    accent: 'bg-blue',
    border: 'border-l-blue',
  },
  {
    number: '04',
    title: 'SMART REVIEW & PROGRESS SYSTEM™',
    subtitle: 'Review Smarter. Reinforce What Matters.',
    body: 'Know what to review, what needs more practice and what children are ready to explore next.',
    tags: 'Review · Reinforcement · Progress · Next Steps',
    accent: 'bg-violet',
    border: 'border-l-violet',
  },
]
